import type { ProductInput } from '../queries/use-add-to-list'

import { showGlobalLoadingIndicatorVar } from 'lib/apollo/reactive-vars'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { handleRequestErrors } from 'services/error-handler'
import { addSnackbar } from 'services/Snackbar/Snackbars'

import { paths } from '../paths'
import { useAddToListQuery } from '../queries/use-add-to-list'

export const useAddToList = (storeId: string) => {
  const addToList = useAddToListQuery()
  const { t } = useTranslation()
  const router = useRouter()

  return async (list: { id: string; name: string }, product: ProductInput) => {
    showGlobalLoadingIndicatorVar(true)
    try {
      const result = await addToList(list.id, storeId, product)

      addSnackbar({
        text: t('Item added to list', {
          name: result.name,
        }),
        actionText: t('Show shoppinglist'),
        onAction: () => router.push(paths.list(result.id)),
      })
    } catch (e) {
      handleRequestErrors([e])
    }
    showGlobalLoadingIndicatorVar(false)
  }
}
